import { CaosConfigurationHistory } from "@/model/data/caosConfiguration/CaosConfigurationHistory";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetConfigurationHistoryEventsResData extends ApiGenericResponse {
    caosConfigurationHistory: CaosConfigurationHistory[];
    totalEvents: number;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.CaosConfigurationHistory) {
            this.caosConfigurationHistory = new Array<CaosConfigurationHistory>();
            obj.CaosConfigurationHistory.forEach((element) => {
                let c = new CaosConfigurationHistory();
                c.parse(element);
                this.caosConfigurationHistory.push(c);
            });
        }
        if (obj.TotalEvents != null && obj.TotalEvents != undefined) this.totalEvents = obj.TotalEvents;
    }
}
